<template>
  <div class="headContainer">
    <div class="el-header">
      <div class="left">
        <div class="title_log">
            <img alt="" src="../../../src/static/index/logo_white.png" />
        </div>
      </div>

      <div class="portrait">
        <!-- 中英切换 -->
        <div class="enlish">
          <!-- <div class="language" @click="changeLang()">
            <div v-if="toggle" class="chese">CH</div>
            <div v-else class="english">EN</div>
          </div> -->
        </div>

        <div class="menu">
          <img
            src="../../../src/static/菜单icon.png"
            alt=""
            v-if="!popupDrawer"
            @click="popupDrawer = true"
          />
          <img
            src="../../../src/static/error.png"
            alt=""
            v-else
            @click="popupDrawer = false"
          />
        </div>
      </div>
    </div>
    <!-- 菜单弹窗开始 -->
    <div class="menu">
      <el-drawer
        title="我是标题"
        :visible.sync="popupDrawer"
        :with-header="false"
        :size="size"
      >
        <div class="menuItem">
          <el-collapse v-model="activeNames" @change="handleChange" accordion>
            <el-collapse-item
              :name="index"
              v-for="(item, index) in menu"
              :key="index"
              :disabled="fold(item)"
            >
              <!-- 菜单主栏目 -->
              <template slot="title"
                ><a @click="enterPage(item.path, item.params)"
                  ><div
                    class="mainTitle"
                    :class="[!item.children ? 'mainBan' : '']"
                  >
                    {{ item.title }}
                  </div>
                </a>
              </template>

              <!-- 判断是否具有下级菜单 -->
              <div class="submenu" v-if="item.children">
                <div class="itemMenu" v-for="(i, k) in item.children" :key="k">
                  <a @click="enterPage(i.path, i.params)"
                    >{{ i.title }}
                    <div
                      :class="lang == 'zh' ? 'dot' : 'dot1'"
                      v-if="i.path == 'mineMessage' && count2 != 0"
                    >
                      <el-badge :is-dot="count2 != 0 ? true : false"></el-badge>
                    </div>
                  </a>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-drawer>
    </div>
    <!-- 菜单弹窗结束 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisiblealert"
      :title="$t('common.tip')"
      width="80%"
    >
      <span>{{ $t("navbar.surelogout") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="sure()">{{
          $t("navbar.sure")
        }}</el-button>
        <el-button size="small" @click="cancel()">{{
          $t("navbar.cancel")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      dialogVisible: false, //
      dialogVisiblealert: false, //注销模态框
      // backFront: backFront(),
      fullscreen: false,
      defaultActive: "",
      num: false,
      lang: "",
      size: "44vw", //弹框的尺寸
      goFlag: false,
      popupDrawer: false, //打开菜单弹窗
      toggle: false,
      tableData: "",
      menu_disabled: false,
      //VR上传资料相关的视频和图片地址
      // VrUploadData: {
      //   uploadImg: config.vrUploadImg,
      //   uploadVideo: config.vrUploadVideo,
      // },
      lang: "zh",
      //菜单列表
      menu: [
        {
          title: this.$t("navbar.home"),
          path: "index",
        },
        {
          title: "论坛介绍",
          path: "",
          params: "",
          children: [
            {
              title: "论坛介绍",
              path: "forum",
            },
            {
              title: "参会指南",
              path: "guide",
            },
            {
              title: "演讲嘉宾",
              path: "guestSpeaker",
            },
          ],
        },
        {
          title: "日程安排",
          path: "",
          children: [
            {
              title: "主论坛",
              path: "mainForum?id=2",
            },
            {
              title: "分论坛一",
              path: "mainForum?id=3",
            },
            {
              title: "分论坛二",
              path: "mainForum?id=4",
            },
          ],
        },
        {
          title: "参会报名",
          path: "",
          children: [
            {
              title: "报名发言",
              path: "toSpeak",
            },
            {
              title: "报名听会",
              path: "sinSpeak",
            },
          ],
        },
        {
          title: "赞助机会",
          path: "sponsor",
        },
        {
          title: "媒体合作",
          path: "",
          children: [
            // {
            //   title: "论坛新闻",
            //   path: "news",
            // },
            {
              title: "合作媒体",
              path: "workMedia",
            },
          ],
        },
        {
          title: "上届论坛",
          path: "lastForum",
        },
        {
          title: "下载中心",
          path: "download",
        },
        {
          title: "联系我们",
          path: "contact",
        },
      ],
      //折叠面板
      activeNames:'论坛介绍',
      mobile: "",
      VrLoginFlag: false, //控制VR误触单点登录
    };
  },

  created() {
    const language = localStorage.getItem("lang");
    this.$i18n.locale = language == "en" ? language : "zh";
    this.lang = language ? language : "zh";
    this.toggle = language == "en" ? true : false;

    // console.log("count得总数",this.count2);
    if (language !== "en") {
      localStorage.setItem("lang", "zh");
    }
  },
  methods: {
    unread(arr) {
      let count = 0;
      arr.forEach((item, index) => {
        if (item.count != 0) {
          count += 1;
        }
      });
      return count;
    },
    cancel() {
      this.dialogVisible = false;
    },
    // 切换语言包
    changeLang(e) {
      if (this.popupDrawer == true) {
        this.popupDrawer = false;
      }
      if (this.toggle == true) {
        // 当前显示的是中文图标,说明页面内容是英文,
        // todo: 把图标变为英文图标，内容变为中文
        this.toggle = false;
        localStorage.setItem("lang", "zh");
        this.$i18n.locale = "zh";
        this.lang = "zh";
        // 存到localStorage的语言是zh
      } else if (this.toggle == false) {
        // 当前显示的是英文图标,说明页面内容是中文,
        // todo: 把图标变为中文图标，内容变为英文
        this.toggle = true;
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        this.lang = "en";
        // 存到localStorage的语言是en
      }
      window.location.reload();
    },
    //------------------------------
    //折叠面板的方法
    handleChange(val) {
      //  console.log(val);
    },
    //是否可展开
    fold(item) {
      return item.children ? false : true;
    },

    //路由跳转
    enterPage(path, parameter) {
      if (path == "") {
        return false;
      }

      if (path !== "1" && path !== "2") {
        this.$router.push(path);
      }

      const arr = ["personInfo", "collectionInfo"];
      const address = parameter;
      for (let i in arr) {
        if (arr[i] == path) {
          this.$router.push({
            name: String(path),
          });
          this.popupDrawer = false;
          return false;
        }
      }
      this.popupDrawer = false;
    },

    //调用VR同步登录函数
    entryVr(id, url) {
      const exId = id; //展商Id
      if (true) {
        let that = this;
        const VrLoginData = { ...VRLogin(exId, that) };
        var hzExhibitor_id = VrLoginData.hzExhibitor_id;
        var time = parseInt(new Date().getTime() / 1000);
        var sign = VrLoginData.sign;
        var url = `${config.vrUrl}/ckjump/login?hzExhibitor_id=${hzExhibitor_id}&sign=${sign}&time=${time}&url=${url}`;
        var a = document.createElement("a");
        a.href = url;
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
  },
};
</script>
<style scoped>
* {
  margin: 0px;
  padding: 0px;
  text-decoration: none;
}
.menuItem {
  padding: 0 15px;
}
.headContainer {
  height: 13.3vw !important;
}
.el-header {
  width: 100%;
  height: 13.5vw !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: url("../../../src/static/backImg.png") no-repeat;
  box-sizing: border-box;
  position: relative;
  z-index: 9999;
  position: fixed;
  top: 0px;
  left: 0px;
}
/* ------------------------------------------- */
.title_log img {
     max-width: 280px;
  height: 38px;
  margin-left: 15px;
}

.link {
  font-size: 18px;
  font-weight: 500;
  color: #006fb8;
}

.img img {
  height: 62px;
  margin: 0 10px 0 20px;
}

.icon {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.el-menu {
  border: none;
}

.el-menu-item {
  display: flex;
  align-items: center;
}

.el-menu-item:hover {
  background: #e8f6ff;
}

.el-menu-item.is-active {
  background: #e8f6ff !important;
}

.el-main {
  background-color: #f0f2f5;
  color: #333;
  /* padding: 20px 30px !important; */
}

.el-row >>> .el-col-24 {
  width: 220px;
  background: white !important;
}

.left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: white;

  margin-top: 4px;
}

.el-header .title {
  font-size: 21px;
  margin-left: 30px;
}

.right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 25px;
  margin-right: 50px;
  color: white;
}

.icon1 i {
  margin-right: 30px;
}

.portrait {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.portrait .menu {
  width: 18px;
  height: 12px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 25px;
}
.portrait img {
  width: 18px;
  height: 18px;
}

/* ------------------------------------------------------ */

.el-dropdown {
  position: relative;
  top: -2px;
}

.el-dropdown-link {
  cursor: pointer;
  color: white;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.goOnline {
  background: #fff !important;
}
</style>
<style lang="scss" scoped>
.language {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  margin-left: 5px;

  .chese {
    margin-left: 9px;
    margin-right: 5px;
    padding-right: 5px;
    white-space: nowrap;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-right: 6px;
      width: 24px;
      height: 24px;
    }
  }

  .english {
    margin-left: 9px;
    margin-right: 5px;
    padding-right: 5px;
    white-space: nowrap;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-right: 6px;
      width: 24px;
      height: 24px;
    }
  }
}
.logout {
  border: 1px solid red;
  color: white;
  margin-top: 30px;
  border: 1px solid white;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
</style>
<style scoped>
.el-menu-item >>> .el-badge__content.is-fixed.is-dot {
  right: -7px;
}
.dot .el-badge {
  left: 85px;
}
.el-menu-item >>> .el-menu-item * {
  vertical-align: top;
}

.el-menu-item >>> .el-badge {
  display: block !important;
}
</style>
<style scoped lang="scss">
.submenu {
  // margin: 0px 15px;
  box-sizing: border-box;
  background: #10669f;
  /* 调节菜单子项的颜色,尺寸等 */
  .itemMenu {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 25px;
    padding: 0px 25px 0px 25px;
    a {
      color: #ffffff;
      line-height: 25px;
      width: 100%;
      display: block;
      padding: 16px 0px;
      width: 100%;
    }
  }
  .itemMenu:nth-child(4) {
    position: relative;
    .dot {
      position: absolute;
      top: 10px;
      left: 1px;
    }
    .dot1 {
      position: absolute;
      top: 12px;
      left: 120px;
    }
  }
}
.mainTitle {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
  padding: 0px 15px;
}
</style>
<style scoped>
.dialog-footer >>> .el-button--small,
.el-button--small.is-round {
  padding: 9px 15px !important;
  box-sizing: border-box;
}

/* ------------------------------------- */
.menu >>> .el-drawer__body {
  padding-top: 50px;
  background-color: #006fb8;
}

.menu >>> .el-collapse-item__content {
  background: #006fb8;
}
.menu >>> .el-collapse-item__header {
  background: #006fb8;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  color: white;
}
.menu >>> .el-collapse-item__content {
  padding-bottom: 0px;
  line-height: 0px;
}
.menu >>> .el-collapse-item__header {
  position: relative;
}
.mainBan {
  padding: 0 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  left: 1px;
  top: 10px;
  z-index: 999;
  background: #006fb8;
}
.el-badge >>> .el-badge__content {
  background: #ff190c;
}
</style>
